export default {"src":"/_next/static/media/shareIcon.408238bd.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};